// extracted by mini-css-extract-plugin
export var askAiIcon = "_q2-9";
export var container = "_q2-0";
export var groupSeparator = "_q2-a";
export var highlight = "_q2-4";
export var resultIcon = "_q2-5";
export var resultItem = "_q2-7";
export var resultSubtitle = "_q2-3";
export var resultTitle = "_q2-2";
export var resultsList = "_q2-1";
export var searchGroup = "_q2-6";
export var selected = "_q2-8";